import {
  SET_TTS_VOICE,
  SET_TTS_LOCALE,
  SET_ELEVENLABS_TTS_LOCALE,
  SET_ELEVENLABS_TTS_ACCENT,
  SET_ELEVENLABS_TTS_VOICE,
  SET_ELEVENLABS_TTS_GENDER,
} from 'actions/types';

const INITIAL_STATE = {
  locale: null,
  voice: 'male',
  elevenLabs: {
    locale: null,
    accent: '',
    voiceGender: 'female',
    voices: {
      male: '',
      female: '',
    },
  },
};

const filter = 'flinkMake/tts';

export default function(state = INITIAL_STATE, action) {
  if (action.filter !== filter) {
    return state;
  }

  switch (action.type) {
    case SET_TTS_VOICE:
      return {
        ...state,
        voice: action.payload,
      }
    case SET_TTS_LOCALE:
      return {
        ...state,
        locale: action.payload,
      }
    case SET_ELEVENLABS_TTS_LOCALE:
      return {
        ...state,
        elevenLabs: {
          ...(state.elevenLabs || INITIAL_STATE.elevenLabs),
          locale: action.payload,
        },
      }
    case SET_ELEVENLABS_TTS_ACCENT:
      return {
        ...state,
        elevenLabs: {
          ...(state.elevenLabs || INITIAL_STATE.elevenLabs),
          accent: action.payload,
        },
      }
    case SET_ELEVENLABS_TTS_VOICE:
      return {
        ...state,
        elevenLabs: {
          ...(state.elevenLabs || INITIAL_STATE.elevenLabs),
          voices: {
            ...((state.elevenLabs && state.elevenLabs.voices) || INITIAL_STATE.elevenLabs.voices),
            [action.payload.gender]: action.payload.voiceId,
          },
        },
      }
    case SET_ELEVENLABS_TTS_GENDER:
      return {
        ...state,
        elevenLabs: {
          ...(state.elevenLabs || INITIAL_STATE.elevenLabs),
          voiceGender: action.payload,
        },
      }
    default:
      return state;
  }
}
